export const MessageConstants = {
  init: 'init',
  login: 'login',
  logout: 'logout',
  loadPage: 'loadPage',
  loadTab: 'loadTab',
  removeTab: 'removeTab',
  tabOff: 'tabOff',
  openModal: 'openModal',
  closeModal: 'closeModal',
  promptModal: 'promptModal',
  reloadClientMenu: 'reloadClientMenu',
  financialYearsChanged: 'financialYearsChanged',
  selectedYearChanged: 'selectedYearChanged',
  accountLinkComplete: 'accountLinkComplete',
  closeClient: 'closeClient',
  confirmTabClose: 'confirmTabClose',
  sendToClientPortal: 'sendToClientPortal',
  directImportChanged: 'directImportChanged',
  tokenRenewed: 'tokenRenewed',
  save: 'save'
};
